import Header from "./components/Header";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Outlet } from "react-router-dom";
import SideBarMenu from "./components/SideBarMenu";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const matches = useMediaQuery("(min-width:1200px)");
  const sidebarWidth = 270;
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  const [hideSideBar, setHideSideBar] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else {
      setIsLogin(true);
    }
  });

  return (
    <>
      {!isLogin ? null : (
        <>
          <Box
            sx={{
              position: "fixed",
              width: "100%",
              zIndex: 1000,
            }}
          >
            <Header hideSideBar={hideSideBar} setHideSideBar={setHideSideBar} />
          </Box>
          <Box sx={{ height: 64 }} />
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: matches && !hideSideBar ? "block" : "none",
                minWidth: sidebarWidth,
                // position: "fixed",
              }}
            >
              <SideBarMenu />
            </Box>
            <Box
              component={"div"}
              sx={{
                pl: 2,
                height: "calc(100vh - 64px)",
                overflowY: "auto",
                width:
                  hideSideBar || !matches
                    ? "99%"
                    : `calc(99% - ${sidebarWidth}px)`,
                // ml: matches ? `calc(${sidebarWidth}px + 16px)` : "16px",
              }}
            >
              <Outlet />
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default App;
